import { useGameStore } from '../state/useGameStore';

export function resolveKillStreakLabel(count: number): string {
  if (count <= 1) return '';
  if (count === 2) return 'DOUBLE KILL';
  if (count === 3) return 'TRIPLE KILL';
  if (count === 4) return 'QUAD KILL';
  return 'KILLING SPREE';
}

export function KillStreakBanner() {
  const killStreak = useGameStore((s) => s.killStreak);
  const lastKillTime = useGameStore((s) => s.lastKillTime);
  const label = resolveKillStreakLabel(killStreak);

  if (!label) return null;

  const elapsed = Date.now() - lastKillTime;
  if (elapsed > 2500) return null;

  const opacity = Math.max(0, 1 - elapsed / 2500);

  return (
    <div
      style={{
        position: 'fixed',
        top: 80,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 210,
        opacity,
      }}
    >
      <div
        style={{
          fontSize: 48,
          fontWeight: 900,
          color: '#ffffff',
          fontFamily: 'monospace',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          textShadow: '0 0 20px #ff8800, 0 0 40px #ff4400',
          userSelect: 'none',
        }}
      >
        {label}
      </div>
    </div>
  );
}
